import EventClass from "common/utils/ui/event-class";

// eslint-disable-next-line import/prefer-default-export
export class ProductsFilterCollapseSectionsClass extends EventClass {
  #linkedParam = "";

  constructor(props) {
    super(props);

    this.#linkedParam = props.linkedParam;
  }

  toggleCollapse(sectionName) {
    const linkedSections = document.querySelectorAll(`[${this.#linkedParam}="${sectionName}"]`);

    linkedSections.forEach($section => {
      $section.classList.toggle("hidden");
    });
  }

  event(event, $target) {
    super.event(event, $target);

    this.toggleCollapse($target.dataset.section);
  }
}
